export const flightArrangementTravelerOption = {
  reservedBaggageDisplay:
    "{{weight}} {{weightUnit}}まで ({{quantity}}個)： {{price}}",
};
